import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { registerServiceWorker } from './utils/registerSW';
import { initPerfMonitor } from './utils/perf';
import { initPostHog } from './lib/posthog';
import { initGtag } from './lib/gtag';

initPerfMonitor();
initPostHog();
initGtag();

async function mount(): Promise<void> {
  const root = await import('./App').then(({ default: App }) => (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  ));

  // Marketing routes ship build-time prerendered HTML inside #root (see
  // scripts/prerender-seo.mjs) — hydrate it. SPA-only routes get an empty
  // shell (spa/index.html) and render from scratch.
  const container = document.getElementById('root')!;
  if (container.hasChildNodes()) {
    ReactDOM.hydrateRoot(container, root);
  } else {
    ReactDOM.createRoot(container).render(root);
  }
}

mount();

// Offline + cross-session asset caching (production only).
registerServiceWorker();
